import React from 'react'

import { Flex } from 'antd'
import { AIChatCitationFragment } from 'types/graphql'

import AIChatMessage from 'src/components/AIChat/AIChatMessage'
import Text, { TextSize } from 'src/components/Typography/Text'
import { Citation } from 'src/pages/AIChat/AIResponseMessage/Citation'
import ParsedHtmlMessage from 'src/pages/AIChat/AIResponseMessage/ParsedHtmlMessage'
import Toolbar from 'src/pages/AIChat/AIResponseMessage/Toolbar'
import { DateFormats, formatDate } from 'src/utils/date'

type Props = {
  align?: React.CSSProperties['alignSelf']
  handleAIChat?: (text: string) => void
  html: string
  index?: number
  messageId?: number
  sender: 'user' | 'ai'
  sentAt?: string
  showToolbar?: boolean
  isThinking?: boolean
  citations?: AIChatCitationFragment[] | null
  shouldDisableButtons?: boolean
}

const Message = ({
  handleAIChat,
  html: htmlRaw,
  index,
  messageId,
  sender,
  sentAt,
  showToolbar,
  isThinking,
  citations,
  shouldDisableButtons,
}: Props) => {
  // remove trailing "<" or "</" sequences, which html-react-parser doesn't trim
  const html = htmlRaw.replace(/<\/?$/, '')
  return (
    <Flex vertical align={sender === 'user' ? 'flex-end' : 'flex-start'}>
      {sentAt && (
        <Text className="mr-4" size={TextSize.Small}>
          {formatDate(sentAt, DateFormats.Time)}
        </Text>
      )}
      <AIChatMessage
        id={`${messageId}`}
        type={sender === 'user' ? 'User' : 'Assistant'}
        content={
          !!html && (
            <ParsedHtmlMessage
              html={html}
              index={index}
              handleAIChat={handleAIChat}
              shouldDisableButtons={shouldDisableButtons}
            />
          )
        }
        isThinking={isThinking}
        actions={[]}
      />
      {!!citations && citations.length > 0 && (
        <>
          <Text strong>Sources</Text>
          <ul>
            {citations.map((citation) => (
              <li key={citation.id}>
                <Citation citation={citation} />
              </li>
            ))}
          </ul>
        </>
      )}
      {!isThinking && sender === 'ai' && showToolbar && <Toolbar html={html} id={messageId} />}
    </Flex>
  )
}

export default React.memo(Message)
